import React, { useMemo } from 'react'
import { Card, CardHeader, CardTitle, CardBody, DataRow } from '../../../Card'
import { Badge } from '../../../../atoms/Badge'
import type { LandRestrictionsProps } from '../../LandSection.types'
import { translateRdppfZoneName } from '../../../../../utils'
import {
  RestrictionsGrid,
  StatusBadge,
  AffectedTypes,
  TypeChip,
} from './LandRestrictions.styles'

export const LandRestrictions: React.FC<LandRestrictionsProps> = ({
  restrictions,
  affectedCount,
  notAffectedCount,
  notAvailableCount,
  className,
  t,
  tRestrictions,
}) => {
  const affectedRestrictions = useMemo(() => {
    return restrictions.filter(
      (r) => r.cover_area_perc && r.cover_area_perc > 0
    )
  }, [restrictions])

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{t('restrictions.title')}</CardTitle>
      </CardHeader>
      <CardBody>
        <RestrictionsGrid>
          <DataRow
            label={t('restrictions.affected')}
            value={
              <StatusBadge $status="warning">
                <Badge variant="warning">{affectedCount}</Badge>
              </StatusBadge>
            }
          />

          <DataRow
            label={t('restrictions.notAffected')}
            value={
              <StatusBadge $status="success">
                <Badge variant="success">{notAffectedCount}</Badge>
              </StatusBadge>
            }
          />

          <DataRow
            label={t('restrictions.notAvailable')}
            value={
              <StatusBadge $status="neutral">
                <Badge variant="default">{notAvailableCount}</Badge>
              </StatusBadge>
            }
          />

          {affectedRestrictions.length > 0 && (
            <DataRow
              label={t('restrictions.affectedTypes')}
              value={
                <AffectedTypes>
                  {affectedRestrictions.map((restriction, index) => (
                    <TypeChip key={`restriction-${index}`}>
                      {tRestrictions
                        ? translateRdppfZoneName(
                            restriction.name,
                            tRestrictions
                          )
                        : restriction.name}
                      {restriction.cover_area_perc !== undefined && (
                        <span>
                          {' '}
                          ({(restriction.cover_area_perc * 100).toFixed(0)}%)
                        </span>
                      )}
                    </TypeChip>
                  ))}
                </AffectedTypes>
              }
            />
          )}
        </RestrictionsGrid>
      </CardBody>
    </Card>
  )
}
